import { numberFormat } from "assets/scripts/utilities/helpers";

export function useCreditLimitRequest({ props }) {
  const { getUsers } = useUserStore();

  const receiversList = ["bhuvnesh@poshn.co"];

  const ccList = [
    "nishantkumar@poshn.co",
    "lucky.garg@poshn.co",
    "rahulgupta@poshn.co",
    "pankaj@poshn.co",
    "syaad@poshn.co",
    "mamta@poshn.co",
    "tyagi.sandeep@poshn.co",
    "shashank@poshn.co",
    "aditya.gupta@poshn.co",
    "rachit@poshn.co",
  ];

  const userPortfolio = computed(() => props.details?.userPortfolio || {});

  const customer = computed(() => props.details?.customer || {});

  const invoice = computed(() => props.details?.invoice || {});

  const formHeading = computed(() => {
    let heading = `Request Increase: ${unref(customer)?.name}`;

    if (unref(customer)?.gstin) {
      heading += ` | ${unref(customer)?.gstin}`;
    }

    return heading;
  });

  const formattedAmount = (amount) => {
    return numberFormat({ number: amount, style: "currency", mfd: 0 });
  };

  const { user } = storeToRefs(useAuthStore());

  const getInitialState = () => {
    return {
      receiversList: [],
      ccList: [],
      htmlContent: `<div>
  <p>Hi Team,</p>

  <p>
    We have received a billing request of <strong>${formattedAmount(props.details?.invoice?.totalInvoiceAmount)}</strong>,&nbsp; which exceeds the available net credit balance for the customer below.
  </p>

  <p>Customer Details:</p>

  <p>
    Customer Name: <strong>${customer?.value.name} | ${customer?.value.gstin}</strong><br>
    Existing Credit Limit: <strong>${formattedAmount(userPortfolio?.value.credit_limit)}</strong> <br>
    Outstanding Balance: <strong>${formattedAmount(userPortfolio?.value.outstanding_receivable_amount)}</strong><br>
    Unused Credits: <strong>${formattedAmount(userPortfolio?.value.unused_credits_receivable_amount)}</strong><br>
    Net Credit Balance: <strong>${formattedAmount(userPortfolio?.value.availableCreditAmount)}</strong>
  </p>

  <p>
    There is a shortfall of <strong>${formattedAmount(userPortfolio?.value.shortFallAmount)}</strong>.
  </p>

  <p>
    We request you to get approval to either increase the credit limit
    or clear the outstanding dues, so that we can proceed further
    with new billing at the earliest.
  </p>

  <p>
    Best regards,<br>
    ${unref(user)?.name}<br>
    Team POSHN<br>
    <a href="mailto:support@poshn.co">support@poshn.co</a>
  </p>
</div>`,
      invoice_id: props.details?.invoice?._id,
    };
  };

  const getReceiversAndCCList = async (list) => {
    try {
      const [buyer, recipientsList, requestor] = await Promise.all([
        getUsers({
          params: {
            includes: unref(customer)?._id,
            isActive: 1,
          },
        }),
        getUsers({
          params: {
            emails: list.join(","), //
            is_internal_user: true,
            isActive: 1,
          },
        }),
        getUsers({
          params: {
            includes: unref(invoice).created_by, //
            is_internal_user: true,
            isActive: 1,
          },
        }),
      ]);

      const recipients = recipientsList?.data.data?.data || [];

      const accountOwner = buyer?.data?.data?.data?.map((user) => {
        return {
          ...user.account_owner,
          type: "account_owner",
        };
      })?.[0];

      const invoiceRequestor = requestor?.data?.data?.data?.map((user) => ({
        ...user,
        type: "invoice_requestor",
      }))?.[0];

      const users = recipients;

      if (accountOwner?.email) {
        users.push(accountOwner);
      }

      if (invoiceRequestor && invoiceRequestor?.email !== accountOwner?.email) {
        users.push(invoiceRequestor);
      }

      return users;
    } catch (error) {
      console.error(error);
    }
  };

  return {
    customer,
    receiversList,
    ccList,
    formHeading,

    getInitialState,
    getReceiversAndCCList,
  };
}
